import i18next, { i18n } from 'i18next'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'
import { none, stateful, Widget, mk_widget } from 'widgets-for-react'
import { jsxToWidget } from '../components/cms/blocks/utils.gen'
import { AppState } from '../components/cms/state/types.gen'
import { emptyAppState, PublicSiteState } from '../components/public_site.main.mod'
import { application } from '../components/public_site/application.mod'
import { beslismatrixPage } from '../components/public_site/custom_pages/beslismatrixPage/beslismatrixPage'
import {
  proxy_page,
  styleguide
} from '../components/public_site/custom_pages/custom_pages.mod'
import { PublicSiteCustomRoutes } from '../components/public_site/custom_pages/types.mod'
import { notfound_page } from '../components/public_site/templates/error_page.mod'
import { footer } from '../components/public_site/templates/footer.mod'
import { header } from '../components/public_site/templates/header.mod'
import { loader } from '../components/public_site/templates/loader.mod'
import { page } from '../components/public_site/templates/page.mod'
import en from '../locales/en'
import nl from '../locales/nl'

export type ProxyPaths = string[]

const i18n = function<I>(options: i18next.InitOptions) {
  i18next.init(options)
  return function(children: JSX.Element): Widget<I> {
    return jsxToWidget<I>(<I18nextProvider i18n={i18next}>{children}</I18nextProvider>)
  }
}

const pageLoader: Widget<never> = jsxToWidget(
  <div style={{ minHeight: '100vh' }}>
    <div style={{ minHeight: '50vh' }}></div>
    {loader.run(() => null)}
  </div>
)

export let bootstrap: (proxyPaths?: ProxyPaths) => void = proxyPaths =>
  ReactDOM.render(
    i18n<AppState<PublicSiteState, PublicSiteCustomRoutes>>({
      lng: 'nl',
      debug: false,
      initImmediate: true,
      resources: { nl, en }
    })(
      stateful<AppState<PublicSiteState, PublicSiteCustomRoutes>>()(
        application(
          { rootpath: '', rootpath_to_ignore: '/portal', login_address: '/portal' },
          header,
          footer,
          notfound_page,
          pageLoader,
          page,
          {
            styleguide,
            proxy_page: proxy_page(proxyPaths),
            form: beslismatrixPage
          }
        )
      )({
        current_widget: none(),
        route: {
          kind: 'initial'
        },
        state: emptyAppState(page)
      }).run(_ => null)
    ).run(_ => null),
    document.getElementById('react-content')
  )
